import { Box } from '@factorialco/deprecated-design-system'
import { OneAlert } from '@factorialco/f0-react/dist/experimental'
import moment from 'moment'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import i18n from 'modules/core/lib/i18n'

import { TranscriptMessages } from 'modules/meetings/components/TranscriptMesssages'
import { useMeetingTranscript } from 'modules/meetings/lib/hooks/useMeetingTranscript'

interface PostMeetingTranscriptProps {
  aiChatOpen: boolean
}

export const PostMeetingTranscript = ({ aiChatOpen }: PostMeetingTranscriptProps) => {
  const { transcriptExpirationTime } = useMeetingTranscript()
  const {
    access: { locale },
  } = useCurrentSession()

  return (
    <Box
      height="full"
      flexGrow
      overflowY="auto"
      gap="s12"
      style={{
        padding: aiChatOpen ? '0 32px' : '0 104px',
        transition: 'padding 0.3s ease-in-out',
      }}
    >
      <TranscriptMessages>
        <OneAlert
          variant="warning"
          title={i18n.t('meetings.meeting.transcript.delete_transcript_warning_title')}
          description={i18n.t('meetings.meeting.transcript.delete_transcript_warning_description', {
            time: moment
              .duration(transcriptExpirationTime ?? 17520, 'hours')
              .locale(locale)
              .humanize(),
          })}
        />
      </TranscriptMessages>
    </Box>
  )
}
